function SetRandomColors(drivers) {
    const color = [
      "576E7A",
      "36ACC2",
      "DC3C2E",
      "FAB200",
      "83B142",
      "FAD630",
    ];
    var DriverColor = new Object();
    if(sessionStorage.getItem("DriverColor") != null){
      var DriverColor = JSON.parse(sessionStorage.getItem("DriverColor"));
    }
    drivers.forEach((Driver) => {
      if (!Driver.image) {
        const random = Math.floor(Math.random() * color.length);
        if(typeof DriverColor[Driver.id] == 'undefined'){
          DriverColor[Driver.id] = color[random];
        }
      }
    });
    sessionStorage.setItem("DriverColor",JSON.stringify(DriverColor));
    return DriverColor;
  }
  export default SetRandomColors;
